import { useQuery } from "@tanstack/react-query";
import {
	GET_SURVEYS,
	GET_SURVEY,
	GET_SURVEY_SUBMISSIONS,
	GET_SURVEY_LINKED_PRODUCTS,
} from "../../keys";
import {
	getMySurveys,
	GetSurveysParams,
	getSurveyById,
	getSurveySubmissions,
	GetSurveySubmissionsParams,
	getSurveyLinkedProducts,
	getSurveysByUserId,
	AdminGetSurveysParams,
} from "@onair/services/surveys";

export const useGetMySurveys = (
	params: GetSurveysParams,
	options = {
		enabled: true,
	},
) => {
	return useQuery({
		queryKey: [GET_SURVEYS, params],
		queryFn: () => getMySurveys(params),
		enabled: options.enabled,
	});
};

export const useGetSurveyDetailQuery = ({
	id,
	enabled = true,
}: {
	id: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: [GET_SURVEY, id],
		queryFn: () => getSurveyById(id),
		enabled,
	});
};

export const useGetSurveySubmissionsQuery = (
	params: GetSurveySubmissionsParams,
) => {
	return useQuery({
		queryKey: [GET_SURVEY_SUBMISSIONS, params],
		queryFn: () => getSurveySubmissions(params),
	});
};

export const useGetSurveyLinkedProductsQuery = (surveyId: string) => {
	return useQuery({
		queryKey: [GET_SURVEY_LINKED_PRODUCTS, surveyId],
		queryFn: () => getSurveyLinkedProducts(surveyId),
	});
};

export const useGetSurveysByUserIdQuery = (
	params: AdminGetSurveysParams,
	options = {
		enabled: true,
	},
) => {
	return useQuery({
		queryKey: [GET_SURVEYS, params],
		queryFn: () => getSurveysByUserId(params),
		enabled: options.enabled && Boolean(params.userId),
	});
};
